import { ActionTypes as types } from 'constants';

const initialState = {
  verified: false,
  resendCode: false,
  phoneNumber: null,
};

const verifyPhone = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.VERIFY_PHONE:
      return Object.assign({}, state, {
        verified: false,
        resendCode: false,
        phoneNumber: action.payload,
      });
    case types.VERIFY_PHONE_SUCCESS:
      return {
        ...state,
        verified: true,
        resendCode: false,
      };
    case types.RESEND_CODE:
      return Object.assign({}, state, {
        ...state,
        verified: false,
        resendCode: false,
      });
    case types.RESEND_CODE_SUCCESS:
      return {
        ...state,
        verified: false,
        resendCode: true,
      };
    case types.RESEND_CODE_FAILURE:
      return Object.assign({}, state, {
        ...state,
        verified: false,
        resendCode: false,
      });
    default:
      return state;
  }
};

export default verifyPhone;
